import { createSlice } from "@reduxjs/toolkit";

const initIsDarkMode = true;

const themeSlice = createSlice({
  name: "themeSlice",
  initialState: {
    isDarkMode: initIsDarkMode === null ? true : initIsDarkMode,
  },
  reducers: {
    toggleMode: (state) => {
      const toggledValue = !state.isDarkMode;
      state.isDarkMode = toggledValue;
      localStorage.setItem("isDarkMode", toggledValue);
    },
  },
});

export default themeSlice.reducer;
export const { toggleMode } = themeSlice.actions;
